// extracted by mini-css-extract-plugin
export default {"root":"IphKed","link":"BuenfI","text":"sdxlGI","logo":"H88SbS"};